import {ObjectRef} from "./Core";
import firebase from "firebase/compat";

export interface VeterinarioRef extends ObjectRef {

}

export interface VeterinarioObject {
  criado_em: firebase.firestore.Timestamp;
  id: string;
  path: string;
  owner: string;
  ativo?: boolean;
  transferido_de?: string;
  transferido_de_nome?: string;
  tipo: 'Veterinário' | 'Zootecnista' | 'Outro';
  tipo_outro: string;
  nome: string;
  telefone: string;
  email: string;
  endereco: string;
  complemento: string;
  cep: string;
  estado: string;
  cidade: string;
  aniversario: string;
  area_atuacao: string[];
  ramo_atuacao: string[];
  ramo_atuacao_outro: string;
  propriedades_atendidas_mes: number;
  vacas_iatf_ano: number;
  conhece_linha_virbac: boolean;
  ja_usou_produto_virbac: boolean;
  usou_bovigen_repro_total: boolean;
  usou_bovigen_lepto8: boolean;
  usou_bovigen_v4j5: boolean;
  usou_fosfosal: boolean;
}


export const getVeterinarioRefLabel = (instance: VeterinarioObject): string => {
  return `Veterinário: ${instance.nome}`;
}
